import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { Page, PageRequestParams } from '../../common/queryClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectGroupProcessingStatePageSchema } from '../schema/DataObjectGroupProcessingStateSchema';
import {
  DataObjectGroupProcessingStateType,
  DataObjectGroupProcessingStateFilter,
} from '../schema/types';
import { InputDataUrl } from './InputDataUrl';

type AggregatesQueryParams = DataObjectGroupProcessingStateFilter &
  PageRequestParams;

const getInputDataAggregates = (params?: AggregatesQueryParams) =>
  apiClient
    .get<
      Page<DataObjectGroupProcessingStateType>
    >(expand(InputDataUrl.INPUT_DATA_GROUP_PROCESSING_STATES, params))
    .then((response) =>
      DataObjectGroupProcessingStatePageSchema.parse(response.data),
    );

export const useInputDataGroupProcessingStateQuery = createApiQueryHook(
  ['inputDataAggregates'],
  getInputDataAggregates,
);
